import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { EmailListenerService } from "@app/shared-modal/email-modal/email-listener.service";
// import Intercom from '@intercom/messenger-js-sdk';
import { Subject, combineLatest } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CsToastBoxService } from "@app/services";
import { AuthService } from "@app/core";
var SharedModalComponent = /** @class */ (function () {
    function SharedModalComponent(_emailEventService, changeDetection, toast, authService) {
        this._emailEventService = _emailEventService;
        this.changeDetection = changeDetection;
        this.toast = toast;
        this.authService = authService;
        this._unsubscribeAll = new Subject();
        this.subscriptions = [];
        this.aiModalCheck = false;
    }
    SharedModalComponent.prototype.ngOnInit = function () {
        // Intercom({
        //   app_id: 'g31ttpil',
        //   hide_default_launcher: true
        // });
        var _this = this;
        var _combine = combineLatest(this._emailEventService.beforeSend$, this._emailEventService.afterSend$, this._emailEventService.send$)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function () { return _this.changeDetection.markForCheck(); });
        this.subscriptions.push(this._emailEventService.beforeSend$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (data) {
            _this.toast.show('Your email is being sent', 4000);
        }));
        this.subscriptions.push(this._emailEventService.send$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (component) {
            component.processEmail();
        }));
        this.subscriptions.push(_combine);
        this.aiModalCheck = this.authService.permitted(['SetupAICommunicationEmails.writeaccess']) === true;
    };
    SharedModalComponent.prototype.onKeyDown = function (event) {
        if (event.key) {
            var key = event.key.toLowerCase();
            // Windows/Linux: Alt
            // Mac: Option is also "altKey", Command is "metaKey"
            var altOrOption = event.altKey;
            var cmd = event.metaKey;
            if ((altOrOption || cmd) && (key === 'h' || event.code === 'KeyH')) {
                event.preventDefault();
                if (this.aiModalCheck) {
                    this.triggerAidenModal();
                }
            }
            if ((altOrOption && key === 'c') || key === 'escape') {
                event.preventDefault();
                this.triggerAidenCancelButton();
            }
        }
    };
    SharedModalComponent.prototype.triggerAidenModal = function () {
        var iframe = document.getElementById('email-template-message_ifr');
        var el = iframe.contentDocument.getElementById('aiden-modal-trigger');
        if (el) {
            el.dispatchEvent(new Event('click', { bubbles: true }));
            el.click();
        }
    };
    SharedModalComponent.prototype.triggerAidenCancelButton = function () {
        // const iframe = document.getElementById('email-template-message_ifr') as HTMLIFrameElement;
        var el = document.getElementById('aiden-modal-cancel-button');
        if (el) {
            el.dispatchEvent(new Event('click', { bubbles: true }));
            el.click();
        }
    };
    SharedModalComponent.prototype.ngOnDestroy = function () {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
        this.subscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
    };
    return SharedModalComponent;
}());
export { SharedModalComponent };
